// window.vrnetworld.countdown = {}

(function ($) {
  var that = {};

  that.updateCountdown = function (date) {
    $('#countdown-timer').mbComingsoon({
      expiryDate: date
    });
  };

  that.updateCountdownFront = function (date) {
    $('#countdown-timer-front').mbComingsoon({
      expiryDate: date
    });
  };

  /**
   *
   * @param date
   * @param selector
   */
  that.startCountdown = function (date, selector) {
    if(selector === undefined || selector === '') {
      selector = '#countdown-timer';
    }

    if(selector === '#countdown-timer-front') {
      $(selector).mbComingsoon({
        expiryDate: date,
        interval: Number,
        localization: {
          days: "Tage<span class='hide-hour'>, </span>",
          hours: "Stunden<span class='hide-minute'>, </span>",
          minutes: "<span class='hide-minute'>Minuten </span><span class='hide-second'>und </span>",
          seconds: "<span class='hide-second'>Sekunden</span>"
        },
        speed: 0,
        callBack: function () {
          that.showCountdownInfo();
        }
      });
    } else {
      $(selector).mbComingsoon({
        expiryDate: date,
        interval: Number,
        localization: {
          days: "Tage<span class='hide-hour'>, </span>",
          hours: "Stunden<span class='hide-minute'>, </span>",
          minutes: "<span class='hide-minute'>Minuten </span><span class='hide-second'>und </span>",
          seconds: "<span class='hide-second'>Sekunden</span>"
        },
        speed: 0,
        callBack: function () {
          getLibObject("player").determineMode();
        }
      });
    }
  };

  /**
   *
   */
  that.showCountdownInfo = function() {
    var referenten = $("#experts").find(" header").attr("data-referenten"),
      el_countdown = $("#countdown");
    var current_topic = el_countdown.data('jetzt'),
      player_topic = $('#video').data('jetzt'),
      link = el_countdown.data('link');
    var text = (referenten && referenten !== "") ? "Jetzt Vortrag von " + referenten : "Vortrag im Gange";

    if (typeof current_topic !== 'undefined') {
      text = current_topic;
    }
    if (typeof player_topic !== 'undefined') {
      text = player_topic;
    }
    if(text === '' || typeof text === 'undefined') {
      text = 'Jetzt';
    }
    if (typeof link !== 'undefined') {
      if(link.includes(window.location.hostname)) {
        text = '<a class="live" href="' + link + '#player">' + text + ' <i class="icon-pfeil-rechts"></i></a>';
      } else {
        text = '<a class="live" href="' + link + '">' + text + ' <i class="icon-pfeil-rechts"></i></a>';
      }
    }
    el_countdown.find(" > div > p").html(text);
  };


    that.startEvent = function() {
        getLibObject("player").determineMode();
        that.activateQuestionBox();
        $('#playerHeader').remove();
        if (window.location.hash === '') {
            $.smoothScroll({scrollTarget: window.vrnetworld.config.startEventScrollTarget});
        }
    };

  that.setPlaceHolder = function(element) {
    $(element).attr("placeholder", "FRAGE STELLEN");
  };

  that.deactivateQuestionBox = function() {
    var el_commentline = $('#commentline');
    el_commentline.find(' #comment').attr("disabled", "disabled");
    el_commentline.find(' #submit').attr("disabled", "disabled");
  };

  that.activateQuestionBox = function() {
    var el_commentline = $('#commentline');
    if(!el_commentline.hasClass('chat-restricted')) {
      el_commentline.find(' #comment').removeAttr("disabled");
      el_commentline.find(' #submit').removeAttr("disabled");
    }
  };

  window.vrnetworld.countdown = that;
})(jQuery); // Fully reference jQuery after this point.
